import type { ExtraServiceCondition } from '../../routes/reducers/types';
import ExtraServiceIcon from './ExtraServiceIcon';

interface ExtraServiceRowProps {
  extraServiceConditions: ExtraServiceCondition[];
}

export default function ExtraServicesRow({
  extraServiceConditions,
}: ExtraServiceRowProps): JSX.Element {
  return (
    <div>
      {extraServiceConditions.map((esc) => (
        <ExtraServiceIcon key={esc.id} extraServiceCondition={esc} />
      ))}
    </div>
  );
}
